import { render, staticRenderFns } from "./someAction.vue?vue&type=template&id=9b1b8fec&scoped=true&"
import script from "./someAction.vue?vue&type=script&lang=js&"
export * from "./someAction.vue?vue&type=script&lang=js&"
import style0 from "./someAction.vue?vue&type=style&index=0&id=9b1b8fec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1b8fec",
  null
  
)

export default component.exports